import { Link } from 'react-router-dom';
import './style.css';

const HomeQuoteCTA = () => (
  <section className="section home-quote-cta" aria-labelledby="home-quote-title">
    <div className="container">
      <div className="project-request__wrapper home-quote-cta__wrapper">
        <div className="project-request__panel home-quote-cta__panel">
          <div className="home-quote-cta__copy">
            <h2 className="home-quote-cta__title" id="home-quote-title">
              Нужны CAD-чертежи или BIM-модель по облаку точек?
            </h2>
            <p className="home-quote-cta__text">
              Пришлите информацию о проекте и, если возможно, ссылку на исходные
              данные. Мы оценим объём работ, требования и сроки.
            </p>
          </div>
          <Link to="/contacts" className="btn home-quote-cta__button">
            Получить оценку проекта
          </Link>
        </div>
      </div>
    </div>
  </section>
);

export default HomeQuoteCTA;
